import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-sim",
  "use": "icon-soc-sim-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-sim\">\r\n<g transform=\"translate(-176.128 -240.640) scale(1.344000)\">\r\n<path d=\"M192 256h640v512H192V256zm96 96v320h448V352H288z\" />\r\n  <path d=\"M384 448h64v128h-64V448zm192 0h64v128h-64V448z\" />\r\n  <path d=\"M448 800h128v64H448v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-sim.svg
// module id = 1SGP
// module chunks = 534